import { ComponentPropsWithRef, FC } from 'react';
import s from './CardV2.module.scss';
import cn from 'classnames';

interface Props extends ComponentPropsWithRef<'div'> {
	variant?: 'primary' | 'light' | 'pale_primary' | 'pale_gray';
}

export const CardV2: FC<Props> = (props) => {
	const {
		className, //
		variant = 'light',
		...divProps
	} = props;

	return (
		<div
			{...divProps}
			className={cn(s.card, s[`card_${variant}`], className)}
		/>
	);
};
